import React from "react";
import TripCaliberLogo from "../Content/Images/logo.svg";
const AirplaneLoader = ({ message = "We are going to next section..." }) => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 99999,
    background: "rgba(0,0,0,0.6)",
    display: "flex", alignItems: "center", justifyContent: "center"
  }}>
    <div style={{
      background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)",
      borderRadius: "20px",
      padding: "40px 48px",
      display: "flex", flexDirection: "column",
      alignItems: "center", gap: "28px",
      boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
      minWidth: "380px"
    }}>
      <img
      src={TripCaliberLogo}
        alt="TripCaliber Logo"
        style={{ width: "160px", filter: "brightness(0) invert(1)", opacity: 0.9 }}
      />

      <div style={{ position: "relative", width: "300px", height: "80px" }}>
        <div style={{
          position: "absolute", top: "0px", left: "0",
          width: "100%", display: "flex", justifyContent: "space-between",
          animation: "fadeCloud 1.5s ease-in-out infinite alternate"
        }}>
          <span style={{ fontSize: "22px", opacity: 0.4 }}>☁️</span>
          <span style={{ fontSize: "16px", opacity: 0.3 }}>☁️</span>
          <span style={{ fontSize: "24px", opacity: 0.4 }}>☁️</span>
        </div>
        <div style={{
          position: "absolute", top: "18px", fontSize: "36px",
          animation: "flyPlane 2s ease-in-out infinite alternate",
          filter: "drop-shadow(0 4px 12px rgba(99,179,237,0.5))"
        }}>✈️</div>
        <div style={{
          position: "absolute", bottom: "0", left: "0",
          width: "100%", height: "4px",
          background: "linear-gradient(90deg, transparent, #60a5fa, #3b82f6, #60a5fa, transparent)",
          borderRadius: "2px",
          animation: "glowLine 1.5s ease-in-out infinite alternate"
        }} />
      </div>

      <div style={{ textAlign: "center" }}>
        <p style={{
          color: "#fff", fontSize: "18px", fontWeight: 600,
          margin: 0, animation: "fadeText 1.5s ease-in-out infinite alternate"
        }}>
          {message}
        </p>
        <p style={{ color: "#93c5fd", fontSize: "13px", margin: "8px 0 0", opacity: 0.8 }}>
          Please wait while we prepare your booking
        </p>
        <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "14px" }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{
              width: "10px", height: "10px", borderRadius: "50%", background: "#3b82f6",
              animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite`
            }} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes flyPlane {
          0%   { left: 0px;   transform: translateY(0px) rotate(5deg); }
          100% { left: 255px; transform: translateY(-12px) rotate(-3deg); }
        }
        @keyframes glowLine {
          0%   { opacity: 0.5; }
          100% { opacity: 1; box-shadow: 0 0 12px #3b82f6; }
        }
        @keyframes fadeText {
          0%   { opacity: 0.7; }
          100% { opacity: 1; }
        }
        @keyframes fadeCloud {
          0%   { opacity: 0.3; transform: translateX(0); }
          100% { opacity: 0.6; transform: translateX(8px); }
        }
        @keyframes dotBounce {
          0%, 100% { transform: translateY(0); opacity: 0.4; }
          50%       { transform: translateY(-8px); opacity: 1; }
        }
      `}</style>
    </div>
  </div>
);

export default AirplaneLoader;